import widgetInfo from './widgetInfoSlice';
import mapping from './mappingSlice';

const root = {
	widgetInfo,
	mapping
};

export default root;
